<!-- MAIN CONTAINER -->
<div class="d-flex flex-column vh-100">


    <!-- FIXED SPACE FOR MAIN NAV BAR-->
    <div class="container">
        <div class="row my-3 py-3">
        </div>
    </div>

    <!-- LIST HEADER -->
    <div class="container">
        <div class="card card-body INN-form justify-content-center mt-4">
            <div class="row">

                <!-- LIST TITLE -->
                <div class="col-12 col-lg-5">
                    <h4 class="card-title lg-3 mb-lg-1 text-body-secondary">
                        <i class="bi bi-receipt-cutoff me-2 fs-1 text-primary"></i>Refacturación
                    </h4>
                </div>

                <!-- FUNCTIONS CONTAINER -->
                <div class="col ms-2 m-lg-0 d-lg-flex justify-content-lg-end align-items-lg-center">

                    <!-- FUNCTIONS BUTTONS -->
                    <div class="col-12 col-lg-auto ms-0 ms-lg-2 mt-2 mt-lg-0"><button (click)="agregar(2)" class="INN-function-button link-opacity-50-hover text-decoration-none link-secondary fs-6"><i
                class="bi bi-file-earmark-plus me-2"></i>Agregar</button></div>

                    <!-- SEPARATION BAR -->
                    <div class="INN-functions-separation-bar mx-3 d-none d-lg-block"></div>

                    <!-- SEARCH FORM -->
                    <div class="col-12 col-lg-auto ms-0 mt-2 mt-lg-0">
                        <button data-bs-toggle="collapse" data-bs-target="#searchFilters" [attr.aria-expanded]="isFiltersOpen" class="INN-function-button link-opacity-50-hover text-decoration-none link-secondary fs-6">
                            <i class="bi bi-search me-2"></i>Filtros de búsqueda
                        </button>
                    </div>

                </div>



            </div>
        </div>
    </div>

    <!-- LIST CONTENT -->
    <div class="container">
        <div class="p-0 p-md-3 card card-body INN-form justify-content-center mt-2">

            <!-- SEARCH FILTER BAR -->
            <div class="collapse" id="searchFilters" [class.collapse]="!isFiltersOpen">
                <div class="card card-body bg-primary-subtle border-0 mb-3">
                    <!-- MENU FIELD -->
                    <div class="row g-3">
                        <div class="col-lg-2">
                            <button (click)="recargarPagina()" class="btn btn-sm btn-outline-secondary w-100" type="button">
                              <i class="bi bi-arrow-counterclockwise me-2"></i>Restaurar
                            </button>
                        </div>

                        <div class="col-lg-2">
                            <select class="form-select form-select-sm" id="estatus" name="estatus" [(ngModel)]="estatus" (change)="onFiltrosChange('')">
                                <option value=null disabled>Estatus...</option>
                                <option *ngFor="let statu of status" [value]="statu">{{ statu }}</option>
                            </select>
                        </div>

                        <!-- MENU FIELD -->
                        <div class="col-lg-4">
                            <select class="form-select form-select-sm" id="proyecto" name="proyecto" [(ngModel)]="proyecto" (change)="onFiltrosChange('')">
                              <option value=null disabled>Proyecto...</option>
                                <ng-container *ngFor="let proyecto of proyectos">
                                  <option *ngIf="proyecto.Pry_Activo === true" [value]="proyecto.Id_Proyecto">
                                    {{proyecto.Pry_Clave}}
                                  </option>
                                </ng-container>
                              </select>
                        </div>
                        
                        <div class="col-lg-2">
                            <select class="form-select form-select-sm" id="anio" name="anio" [(ngModel)]="anio" (change)="onFiltrosChange('')">
                                <option value=null disabled>Año de servicio...</option>
                                <option *ngFor="let anioItem of anios; trackBy: trackByFn" [ngValue]="anioItem">
                                    {{ anioItem }}
                                </option>
                            </select>
                        </div>

                        <div class="col-lg-2">
                            <div class="input-group input-group-sm">
                                <input type="text" class="form-control" placeholder="No. De refacturación" aria-label="Buscador" aria-describedby="boton-busqueda" [(ngModel)]="buscar" (keydown.enter)="onFiltrosChange('')">
                                <button class="btn btn-outline-secondary" type="button" id="boton-busqueda" (click)="onFiltrosChange('')">
                                  <i class="bi bi-search"></i>
                                </button>
                            </div>
                        </div>

                    </div>
                </div>
            </div>

            <!-- TABLE -->
            <div class="table-responsive">
                <div *ngIf="!loading && refacturas.length === 0">
                    <p colspan="7"> {{mensajeRefactura}} </p>
                </div>

                <table class="table INN-min-width-lg mb-0 mb-md-3" *ngIf="!loading && refacturas.length > 0">
                    <thead>
                        <tr class="table-primary">
                            <th class="INN-tl-cell-rounded" scope="row">No. Factura original</th>
                            <th class="" scope="col">No. De refacturación</th>
                            <th class="align-middle" scope="col">VoBo</th>
                            <th class="" scope="col">Proyecto</th>
                            <th class="" scope="col">Importe</th>
                            <th class="" scope="col">Año de servicio</th>
                            <th class="INN-tr-cell-rounded" scope="col"></th>
                        </tr>
                    </thead>
                    <tbody>
                        <ng-container *ngFor="let refactura of refacturas">
                            <tr class="table" *ngIf="refactura.FacPro_Activo === true && refactura.FacPro_IdFOrigen !== null && refactura.FacPro_Tipo === 'REFACTURA'">
                                <td class="">{{refactura.NoFactura_Original}}</td>
                                <td class="">{{refactura.FacPro_NoFactura}}</td>
                                <td class="">
                                    <span *ngIf="refactura.FacPro_VoBo === 'Pendiente'" class="badge px-3 py-1 fs-6 bg-info me-1">Pendiente</span>
                                    <span *ngIf="refactura.FacPro_VoBo === 'Aclaracion'" class="badge px-3 py-1 fs-6 bg-warning me-1">Aclaración</span>
                                    <span *ngIf="refactura.FacPro_VoBo === 'VoBo'" class="badge px-3 py-1 fs-6 bg-success">VoBo</span>
                                </td>
                                <td class="">{{refactura.Pry_Clave}}</td>
                                <td class="">${{formatNumberWithCommas(refactura.FacPro_Importe)}}</td>
                                <td class="d-none d-md-table-cell">{{ refactura.FacPro_AnoServicio ? refactura.FacPro_AnoServicio.slice(0, 10) : 'Año no disponible' }}</td>
                                <td class="text-end">
                                    <button (click)="editar(1, refactura)" class="INN-function-button p-0">
                                      <i class="bi bi-arrow-up-right-square-fill link-secondary link-opacity-50-hover text-decoration-none fs-6"></i>
                                    </button>
                                </td>
                            </tr>
                        </ng-container>
                    </tbody>
                </table>
            </div>

        </div>
    </div>

    <!-- LIST FOOTER -->
    <div *ngIf="refacturas.length !== 0" class="container">
        <div class="card card-body INN-form mt-2 mb-4">
            <div class=" row">
                <div class="col-4  d-none d-md-block"></div>
                <!-- Paginación en la primera columna, centrada -->
                <div class="col-lg-4 col-md-12 d-flex align-items-center justify-content-lg-center justify-content-center">

                    <nav aria-label="Page navigation ">
                        <ul class="pagination">
                            <li class="page-item" [class.disabled]="currentPage === 1">
                                <a class="page-link" (click)="changePage(currentPage - 1)"> &laquo; </a>
                            </li>
                            <ng-container *ngFor="let page of visiblePages">
                                <li class="page-item" *ngIf="page === '...'">
                                    <a class="page-link">...</a>
                                </li>
                                <li class="page-item" *ngIf="page !== '...'">
                                    <a class="page-link" (click)="changePage(page)" [class.active]="page === currentPage">{{ page }}</a>
                                </li>
                            </ng-container>
                            <li class="page-item" [class.disabled]="currentPage === totalPages">
                                <a class="page-link" (click)="changePage(currentPage + 1)"> &raquo; </a>
                            </li>
                        </ul>
                    </nav>
                </div>

                <div class="col-lg-4 col-md-12">
                    <div class="row">
                        <div *ngIf="this.totalPages > 1" class="col-lg-6 col-md-6 col-sm-12 d-flex align-items-center justify-content-center justify-content-lg-start">
                            <p class="ms-1 my-auto text-info me-2 text-center text-lg-start mt-2">Elementos por página</p>
                        </div>

                        <div *ngIf="this.totalPages > 1" class="col-lg-6 col-md-5 col-sm-12 mt-md-1">
                            <select class="form-select form-select-sm" id="mostrar" [(ngModel)]="rango" (change)="onFiltrosChange('paginas')">
                                <option *ngFor="let opcion of opciones" [value]="opcion">{{ opcion }}</option>
                            </select>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- FORM FOOTER -->
    <div class="container">
        <div class="row mb-4 pb-4">
        </div>
    </div>

</div>
<!-- END MAIN CONTAINER -->

<app-loading [loading]="loading" [message]="mensajeLoading" [progressPercentage]="progress" [loadingDocuments]="isDocumentLoading"></app-loading>